var clusterDefaultSide = {
	'com': 'la',
	'eu' : 'ie'
};
var dir = document.URL.substring(0, document.URL.lastIndexOf('/')) + "/";
var urlPattern = /https?:\/\/api\.telogis\.\w*\/?.*|https?:\/\/api-preview\.telogis\.\w*\/?.*/i;
var customerUrlPattern = /https?:\/\/.*?\.api\.telogis\.\w*\/?.*|https?:\/\/.*?-preview\.api\.telogis\.\w*\/?.*/i;
var homeSidePattern = /https?:\/\/\w+-api[0-9]*\.telogis\.\w*\/?.*|https?:\/\/\w+-api-preview[0-9]*\.telogis\.\w*\/?.*/i;
var productionUrlPattern = /https?:\/\/(.*?)\.telogis\.(\w*)\/?.*/i;

export default class URLGenerator {
	static getAuthenticationQueryString() {
		var token = document.getElementById("authToken").value;
		if (token !== "") {
			return "auth=" + token;
		}

		var user = document.getElementById("username").value;
		var pass = document.getElementById("password").value;
		if (user !== "" && pass !== "") {
			return "user=" + encodeURIComponent(user) + "&pass=" + encodeURIComponent(pass);
		}
	}

	static GetURLNoAuth(url) {
		var customer = URLGenerator.needCustomerUrl();
		var urlParts = productionUrlPattern.exec(dir);
		if (customer) {
			var host = urlParts[1];
			if (host.toLowerCase() === 'api') {
				url = dir.replace(host, customer + '.' + host) + url;
			} else {
				url = dir.replace(host, customer + '-preview.api') + url;
			}
		} else if (productionUrlPattern.test(dir) && !customerUrlPattern.test(dir) && !homeSidePattern.test(dir)) {
			var cluster = urlParts[2] || "";
			url = dir.replace('api', (clusterDefaultSide[cluster] || 'la') + '-api') + url;
		}
		return url;
	}

	static GetURL(url,connector) {
		var queryString = URLGenerator.getAuthenticationQueryString();
		var baseurl = URLGenerator.GetURLNoAuth(url);
		url = baseurl + connector + queryString;

		return url;
	}

	static needCustomerUrl() {
		var customer = URLGenerator.getCustomer();
		if (customer !== "" && urlPattern.test(dir)) {
			return customer;
		}
		return null;
	}

	static getCustomer() {
		var customer = document.getElementById("username").value;
		var query = document.getElementById("queryString").value;
		var pattern = /runforuser=[\w:]+/i;

		var runfor = pattern.exec(query);
		if (runfor) {
			customer = runfor[0].replace(/runforuser=/i, '');
		}

		if (customer.indexOf(':') > 0) {
			return customer.substr(0, customer.indexOf(':'));
		}

		return "";
	}
}